import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../../framework/BaseWebComponentController';
import { PackageMiscellaneousFormWebComponent } from '../component/PackageMiscellaneousFormWebComponent';
import { PackageMiscellaneousFormView } from '../view/PackageMiscellaneousFormView';
import { templateMiscellaneousForm } from '../view/template';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';
import { MonthlyProductType } from '../../../../license/types/MonthlyProductType';

export class PackageMiscellaneousFormController extends BaseWebComponentController {
  public component: PackageMiscellaneousFormWebComponent;
  public view: PackageMiscellaneousFormView;
  public viewConstructor: typeof PackageMiscellaneousFormView;

  constructor(component: PackageMiscellaneousFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: PackageMiscellaneousFormView,
      viewTemplate: templateMiscellaneousForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$submitEndpointHealthFeedbackCheckbox,
        event: 'change',
        callback: this.toggleEndpointHealthFeedbackWarningVisibility,
      },
      {
        element: this.view.dom.$useGlobalProtectiveNetworkCheckbox,
        event: 'change',
        callback: this.toggleUseGlobalProtectiveNetworkWarningVisibility,
      },
      {
        element: this.view.dom.$submitQuarantineCheckbox,
        event: 'change',
        callback: this.disableQuarantineHoursDropdown,
      },
    ];
  }

  private toggleEndpointHealthFeedbackWarningVisibility(ev: WebComponentEvent): void {
    this.view.toggleEndpointHealthFeedbackWarningVisibility(ev.detail.checked);
  }

  private toggleUseGlobalProtectiveNetworkWarningVisibility(ev: WebComponentEvent): void {
    this.view.toggleUseGlobalProtectiveNetworkWarningVisibility(ev.detail.checked);
  }

  private disableQuarantineHoursDropdown(ev: WebComponentEvent): void {
    this.view.disableQuarantineHoursDropdown(ev.detail.checked);
  }

  public showSubmitQuarantineSectionByOperationMode(operationMode: MonthlyProductType): void {
    const shouldBeVisible = operationMode === MonthlyProductType.EndpointSecurity;
    this.view.dom.$submitQuarantineCheckbox.disabled = !shouldBeVisible;
    toggleVisibility(this.view.dom.$submitQuarantineSection, shouldBeVisible);
  }

  public resetToDefaultValues(): void {
    this.view.setDefaultValuesForDefaultContext();
  }
}
